import { render, staticRenderFns } from "./TabHorizon.vue?vue&type=template&id=12e257bc&scoped=true&lang=pug&"
import script from "./TabHorizon.vue?vue&type=script&lang=js&"
export * from "./TabHorizon.vue?vue&type=script&lang=js&"
import style0 from "./TabHorizon.vue?vue&type=style&index=0&id=12e257bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e257bc",
  null
  
)

export default component.exports